import React from 'react';
import { FadeIn } from './FadeIn';
export const AudienceSection = () => {
  const forYou = ['Hombres y mujeres de 30 a 55 años', 'Personas que se sienten agotadas al despertar y necesitan un arranque rápido', 'Quienes quieren una solución natural, con ingredientes sencillos', 'Personas con poco tiempo que pueden dedicar 5 minutos para preparar algo efectivo', 'Quienes quieren evitar suplementos artificiales y prefieren alimentos frescos'];
  const notForYou = ['Personas que buscan soluciones mágicas sin cambiar nada en su rutina', 'Quienes no están dispuestos a probar combinaciones de frutas y vegetales', 'Los que buscan recetas complicadas o gourmet', 'Quienes prefieren energizantes artificiales o bebidas procesadas'];
  return <section className="py-20 bg-dark" data-id="element-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-12">
          <FadeIn data-id="element-13">
            <div className="bg-darker p-8 rounded-2xl border-t-4 border-brand-green h-full" data-id="element-14">
              <h3 className="font-serif text-2xl font-bold mb-6 text-white" data-id="element-15">
                Esto ES Para Ti Si...
              </h3>
              <ul className="space-y-4" data-id="element-16">
                {forYou.map((item, index) => <li key={index} className="flex items-start" data-id="element-17">
                    <span className="mr-3 flex-shrink-0" data-id="element-18">✅</span>
                    <span className="text-gray-300" data-id="element-19">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-20">
            <div className="bg-darker p-8 rounded-2xl border-t-4 border-brand-orange h-full" data-id="element-21">
              <h3 className="font-serif text-2xl font-bold mb-6 text-white" data-id="element-22">
                Esto NO Es Para Ti Si...
              </h3>
              <ul className="space-y-4" data-id="element-23">
                {notForYou.map((item, index) => <li key={index} className="flex items-start" data-id="element-24">
                    <span className="mr-3 flex-shrink-0" data-id="element-25">❌</span>
                    <span className="text-gray-300" data-id="element-26">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
};